import React from "react";
import { Prompt, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import TextInput from "./common/TextInput";
import DropDown from "./common/DropDown";
import CheckBox from "./common/CheckBox";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import * as Api from "../api/profile";
import "react-datepicker/dist/react-datepicker.css";
import { round, getFatPctMetric } from "../misc/utils";
import * as global from "../misc/global"

class ProfilePage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            preventRedirect: false,
            isNewProfile: true,
            knowFatPct: false,
            profile: {
                userID: 0,
                birthdate: new Date(),
                bodyType: 0,
                calcMethod: 2,
                dietConviction: 0,
                fatPercentage: 0.0,
                goal: 0,
                height: 0.0,
                isTrainning: false,
                monthsTrainning: 0,
                activityType: 1,
                sex: 0,
                weight: 0.0,
                foodPreference: 4,
                trainningHoursAWeek: 0,
                mealsQty: 3,
                neck: 0,
                waist: 0,
                hip: 0
            }
        };
        this.updateValue = this.updateValue.bind(this);
        this.updateFatPct = this.updateFatPct.bind(this);
        this.handleSave = this.handleSave.bind(this);

        //date time picker language config
        registerLocale(global.culture, global.locale);
        setDefaultLocale(global.culture);
    }

    async componentDidMount() {
        let savedProfile = await Api.getProfile(this.props.user.id);
        if (savedProfile) {
            savedProfile.birthdate = new Date(savedProfile.birthdate);
            let knowFP = savedProfile.calcMethod === 3;
            this.setState({ profile: savedProfile, isNewProfile: false, knowFatPct: knowFP });
        } else {
            this.updateValue(null, null, "userID", this.props.user.id);
        }
    }

    updateValue(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true
    ) {
        if (dataType === "check")
            value = event.target.checked;
        else if (dataType === "select")
            value = Number(event.target.value);

        const updatedObj = { ...this.state.profile, [objName]: value };
        this.setState({ profile: updatedObj, preventRedirect: true });
        //TO DO: verify if the !isValid message is necessary, or if can be usefull for other datatypes
        if (!isValid)
            toast.error("Numero no valido");
    }

    updateFatPct(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true
    ) {
        let updateFatPct = true;
        const updatedObj = { ...this.state.profile };
        if (dataType === "check") {// if comes from KnowFatPct
            value = event.target.checked;
            this.setState({ knowFatPct: value, preventRedirect: true });

            if (value) {// if known
                updateFatPct = false;
                updatedObj.calcMethod = 3;
            }
            else
                updatedObj.calcMethod = 2;
        }
        else {// if comes from any other
            if (this.state.knowFatPct)
                updateFatPct = false;

            if (dataType === "select")// if comes from Sex
                value = Number(event.target.value);

            updatedObj[objName] = value;
            //TO DO: verify if the !isValid message is necessary, or if can be usefull for other datatypes
            if (!isValid)
                toast.error("Numero no valido");
        }

        if (updateFatPct) {
            let newFatPct = round(getFatPctMetric(
                updatedObj.sex,
                updatedObj.height,
                updatedObj.neck,
                updatedObj.waist,
                updatedObj.hip
            ), 2);

            if (isNaN(newFatPct) || newFatPct < 0) {
                newFatPct = 0;
            }
            updatedObj.fatPercentage = newFatPct;
        }
        this.setState({ profile: updatedObj, preventRedirect: true });
    }

    async handleSave(event) {
        event.preventDefault();
        try {
            await Api.addProfile(this.state.profile);
            this.setState({ preventRedirect: false });
            toast.success("Perfil guardado exitosamente");
        }
        catch (error) {
            toast.error("Hubo un error al guardar");
        }
    }

    render() {
        return (
            <>
                <h2>Información de perfil</h2>
                <Prompt
                    when={this.state.preventRedirect}
                    message="Estas seguro que deseas abandonar esta pagina sin guardar tus cambios?"
                />
                <form onSubmit={this.handleSave} autoComplete="off">
                    <fieldset disabled={!this.state.isNewProfile}>
                    <TextInput
                        id="height"
                        label="Altura"
                        dataType="float"
                        value={this.state.profile.height}
                        onChange={this.updateFatPct}
                    />
                    <TextInput
                        id="weight"
                        label="Peso"
                        dataType="float"
                        value={this.state.profile.weight}
                        onChange={this.updateValue}
                    />
                    <div className="row mb-2">
                        <label className="col-sm-3 col-lg-2 col-form-label" htmlFor="tex">Fecha de Nacimiento</label>
                        <div className="col-sm-8 col-lg-4">
                            <DatePicker
                                id="tex"
                                className="form-control"
                                dateFormat="dd/MMM/yyyy"
                                autoComplete="off"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={50}
                                scrollableYearDropdown
                                selected={this.state.profile.birthdate}
                                onChange={date => this.updateValue(this, "Date", "birthdate", date)}
                            />
                        </div>
                    </div>
                    <DropDown id="sex" label="Sexo" value={this.state.profile.sex} onChange={this.updateFatPct} list={[
                        { "id": 0, "text": "Hombre" },
                        { "id": 1, "text": "Mujer" }
                    ]} />
                    <CheckBox id="isTrainning" label="Realizas algun entrenamiento fisico actualmente? (Minimo 3 dias a la semana, al menos 1 hora cada dia)" value={this.state.profile.isTrainning} onChange={this.updateValue} />
                    {this.state.profile.isTrainning && (
                        <TextInput
                            id="monthsTrainning"
                            label="Cuantos meses llevas entrenando?"
                            dataType="int"
                            value={this.state.profile.monthsTrainning}
                            onChange={this.updateValue}
                        />
                    )}
                    <DropDown id="bodyType" label="Tipo de cuerpo actual" value={this.state.profile.bodyType} onChange={this.updateValue} list={[
                        { "id": 0, "text": "Delgado (Ectomorfo)" },
                        { "id": 1, "text": "Fuerte, Muscular(Mesoformo)" },
                        { "id": 2, "text": "Robusto (Endomorfo)" }
                    ]} />
                    <DropDown id="goal" label="Objetivo deseado:" value={this.state.profile.goal} onChange={this.updateValue} list={[
                        { "id": 0, "text": "Bajar de peso (disminuir porcentaje de grasa)" },
                        { "id": 1, "text": "Aumentar masa muscular" },
                        { "id": 2, "text": "Mantenimieto (Mejorar salud)" }
                    ]} />
                    {this.state.profile.goal === 0 && (
                        <DropDown id="dietConviction" label="Que tan rapido quieres bajar de peso?" value={this.state.profile.dietConviction} onChange={this.updateValue} list={[
                            { "id": 0, "text": "Lento" },
                            { "id": 1, "text": "Moderado" },
                            { "id": 2, "text": "Rapido" }
                        ]} />
                    )}
                    <DropDown id="foodPreference" label="Que tipo de dieta prefieres?" value={this.state.profile.foodPreference} onChange={this.updateValue} list={[
                        { "id": 7, "text": "Mucho mas grasas" },
                        { "id": 6, "text": "Mas grasas" },
                        { "id": 5, "text": "Carbohidratos y grasas por igual" },
                        { "id": 4, "text": "Mas carbohidratos (Recomendado)" },
                        { "id": 3, "text": "Mucho mas carbohidratos" }
                    ]} />
                    <DropDown id="mealsQty" label="Cuantas comidas al dia quieres?" value={this.state.profile.mealsQty} onChange={this.updateValue} list={[
                        { "id": 3, "text": "3 (Desayuno,Comida,Cena)" },
                        { "id": 4, "text": "4 (Desayuno,Almuerzo,Comida,Cena)" },
                        { "id": 5, "text": "4 comidas y 1 colación" },
                        { "id": 6, "text": "3 comidas y 1 colación" },
                        { "id": 7, "text": "3 comidas y 2 colaciones" }
                    ]} />
                    <DropDown id="activityType" label="Actividad fisica que realizas" value={this.state.profile.activityType} onChange={this.updateValue} list={[
                        { "id": 1, "text": "Sedentario(Trabajas sentado y no haces ejercicio)" },
                        { "id": 2, "text": "Ligera(trabajas sentado y entrenas 3 o 4 dias por semana, o trabajas de pie todo el tiempo y entrenas menos de 5 dias)" },
                        { "id": 3, "text": "Moderada(Trabajas sentado y entrenas al menos 5 dias por semana. O trabajo pesado y no entrenas )" },
                        { "id": 4, "text": "Alta(trabajas de pie todo el tiempo y entrenas al menos de 5 dias por semana)" },
                        { "id": 5, "text": "Muy alta(trabajo pesado cargando cosas y entrenas diario)" }
                    ]} />
                    <TextInput
                        id="trainningHoursAWeek"
                        label="Cuantas horas a la semana planeas hacer ejercicio"
                        dataType="int"
                        value={this.state.profile.trainningHoursAWeek}
                        onChange={this.updateValue}
                    />
                    <CheckBox id="knowFatPct" label="Conoces tu porcentaje de grasa?" value={this.state.knowFatPct} onChange={this.updateFatPct} />
                    {!this.state.knowFatPct ? (
                        <>
                            <TextInput
                                id="waist"
                                label="Ancho de la cintura"
                                dataType="float"
                                value={this.state.profile.waist}
                                onChange={this.updateFatPct}
                            />
                            <TextInput
                                id="neck"
                                label="Ancho del cuello"
                                dataType="float"
                                value={this.state.profile.neck}
                                onChange={this.updateFatPct}
                            />

                            {this.state.profile.sex === 1 && (
                                <TextInput
                                    id="hip"
                                    label="Ancho de la cadera"
                                    dataType="float"
                                    value={this.state.profile.hip}
                                    onChange={this.updateFatPct}
                                />
                            )}
                            <span>
                                Porcentaje de grasa: {this.state.profile.fatPercentage} <br />{" "}
                                <br />
                            </span>
                        </>
                    ) : (
                        <TextInput
                            id="fatPercentage"
                            label="Porcentaje de grasa"
                            dataType="float"
                            value={this.state.profile.fatPercentage}
                            onChange={this.updateValue}
                        />
                        )}
                    </fieldset>
                    {this.state.isNewProfile && (
                        <input type="submit" value="Guardar" className="btn btn-primary" />
                    )}                  
                </form>
            </>
        );
    }
}
export default withRouter(ProfilePage);
